import React, { Component } from "react";

export default class UsersCell extends Component {
  onCheckChange = (e) => {
    this.props.toggleSelection(this.props.user);
  };

  render() {
    var { username, email, usercategory } = this.props.user;
    var { checked } = this.props;

    return (
      <tr>
        <td style={{ width: "10%", textAlign: "center" }}>
          <label className="checkcontainer">
            <input
              type="checkbox"
              onChange={this.onCheckChange}
              checked={checked}
            />
            <span className="checkcheckmark" />
          </label>
        </td>
        <td>{username}</td>
        {/* <td>{email}</td> */}
        {/* <td style={{textTransform: 'capitalize'}}>{usercategory}</td> */}
      </tr>
    );
  }
}
